// extracted by mini-css-extract-plugin
export default {"Structure_app":"structure_Structure_app__fGpEY","Structure_PCA":"structure_Structure_PCA__Zcan7"};